/*
 * @Description:
 * @LastEditTime: 2024-02-19 16:06:36
 * @LastEditors: 何俊峰
 * @Author: 何俊峰
 * @Date: 2024-02-01 18:02:34
 */
let titles = ['康顺津童守护服务指挥调度中心', '康顺分散供养人员照料护理服务指挥调度中心']
let logoTxts = ['康顺津童守护', '康顺社工服务']
let txts = {
  // 开发使用儿童文案
  'community-admin.yi-types.top': {
    'title': titles[0],
    'logoTxt': logoTxts[0],
    'appImgUrl':"https://www.pgyer.com/app/qrcode/ksKidsUpdate",
    'cusType':'儿童',
  },
  // 测试使用老人文案
  'community-admin-test.yi-types.top': {
    'title': titles[1],
    'logoTxt': logoTxts[1],
    'appImgUrl':"https://www.pgyer.com/app/qrcode/kangshun",
    'cusType':'老人',
  },
  // 正式老人
  'adminks.yiosi.cn': {
    'title': titles[1],
    'logoTxt': logoTxts[1],
    'appImgUrl':"https://www.pgyer.com/app/qrcode/kangshun",
    'cusType':'老人',
  },
  // 正式儿童
  'childks.yiosi.cn': {
    'title': titles[0],
    'logoTxt': logoTxts[0],
    'appImgUrl':"https://www.pgyer.com/app/qrcode/ksKidsUpdate",
    'cusType':'儿童',
  }
}

let defaultTxt = txts['community-admin.yi-types.top']
console.log(window.location.host)
if (txts[window.location.host]) {
  defaultTxt = txts[window.location.host]
}
export default defaultTxt